import { GlobalSearchResultType as ApiGlobalSearchResultType } from 'src/api/generated/touring/types';
import { GlobalSearchResultType } from '../../types';

export const mapGlobalSearchResultType = (
  apiResult: ApiGlobalSearchResultType
): GlobalSearchResultType => ({
  id: apiResult.id,
  label: apiResult.name,
});
